import DevicesCard from './DevicesCard';

export default DevicesCard;
